export default "__VITE_ASSET__wzfvoFzL__"